import { CONTACT_ASSISTANT_API } from 'modules/contacts/api/contact-api'
import { ContactFilterConditionInterface } from 'modules/contacts/types/contact-filter-interface'
import { ContactApiInterface } from 'modules/contacts/types/contact-interface'
import { useCallback } from 'react'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface'
import { baseFetcher } from 'shared/utils/http-client'

interface UseContactsInterface extends SwrPaginationInterface {
  conditions: ContactFilterConditionInterface[]
}

export function useAssistantContacts({ limit, pagination, conditions }: UseContactsInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ContactApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const filterApi = conditions
    .map((el, idx) => {
      return Object.keys(el)
        .map(
          e =>
            `&filter[conditions][${idx}][${e}]=${encodeURIComponent(
              el[e as keyof ContactFilterConditionInterface] as string,
            )}`,
        )
        .join('')
    })
    .join('')

  const { data: contacts, abort: abortList } = useControlledSwr(() => {
    if (user && pagination.startFromId === undefined && limit) {
      return `${CONTACT_ASSISTANT_API}/contacts/list?pagination[limit]=${limit}${filterApi}`
    } else if (user && pagination.startFromId && limit) {
      return `${CONTACT_ASSISTANT_API}/contacts/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`
    }
    return null
  }, fetcher)

  const { data: counter, abort: abortCounter } = useControlledSwr<CountInterface>(() => {
    if (user) {
      return `${CONTACT_ASSISTANT_API}/contacts/count?pagination[limit]${filterApi}`
    }
    return null
  }, baseFetcher)

  const abortContacts = useCallback(() => {
    abortList()
    abortCounter()
  }, [abortCounter, abortList])

  return { contacts, counter, abortContacts }
}
